/**
 * Created by Owner on 2016/8/6.
 * 组选  组选60 组选30  组选20  组选10 组选5
 *  selectArea: {
          layout: [
            {
              title: "组选120",
              no: "0|1|2|3|4|5|6|7|8|9",
              minchosen: 5
            }
          ],
          noBigIndex: 5,
 */
import {Component} from '@angular/core';
import {LotteryMathZXFSComponent} from "./zxfs";
import {ArrayUtil} from "../../util/arrayUtil";
import {MathUtil} from "../../util/mathUtil";

@Component({
  selector: 'lottery-math-zh2',
  templateUrl: 'selectMathAndPostion.html',
})
export class LotteryMathZH2Component extends LotteryMathZXFSComponent {
  ngOnInit() {
  }

  changeTotal(selectInfo:any) {
    let mname: string = this.selectAreaOption["mname"];
    let selectMarkNum: any = this.children.toArray();
    let selLength1: number = selectMarkNum[0].selectNo.length;
    let selLength2: number = selectMarkNum[1].selectNo.length;
    let minchosen1: number = selectMarkNum[0].getSelectOption()["minchosen"];
    let minchosen2: number = selectMarkNum[1].getSelectOption()["minchosen"];
    let selLength = this.defaultPosition.length;
    let isrx = this.selectAreaOption["isrx"];
    var tmp_nums = 0;
    if (selLength1 >= minchosen1 && (selLength2 >= minchosen2)) {
      var h = ArrayUtil.intersect(selectMarkNum[0].selectNo, selectMarkNum[1].selectNo).length;
      tmp_nums = MathUtil.combination(selLength1, minchosen1) * MathUtil.combination(selLength2, minchosen2);
      if (h > 0) {
        if (mname == "WXZU60") {
          tmp_nums -= MathUtil.combination(h, 1) * MathUtil.combination(selLength2 - 1, 2);
        }
        if (mname == "WXZU30") {
          tmp_nums -= MathUtil.combination(h, 2) * MathUtil.combination(2, 1);
          if (selLength1 - h > 0) {
            tmp_nums -= MathUtil.combination(h, 1) * MathUtil.combination(selLength1 - h, 1);
          }
        }
        if (mname == "WXZU20" || mname == "SXZU12") {
          tmp_nums -= MathUtil.combination(h, 1) * MathUtil.combination(selLength2 - 1, 1);
        }
        if (mname == "WXZU10" || mname == "WXZU5" || mname == "SXZU4") {
          tmp_nums -= MathUtil.combination(h, 1)
        }
        if (isrx == 1) {
          tmp_nums *= selLength == 0 ? 0 : MathUtil.combination(selLength, 4)
        }
      }
    }
    this.setTotal(tmp_nums);
  }
}



// WEBPACK FOOTER //
// ./src/component/+lotteryMath/zh2.ts